import tenantReducer from '@sophocles/features/tenant/slice';

export default tenantReducer;
